import axios from 'axios';
import backendDispatcher from 'Cloud/Application/Upload/tools/cloud/backendDispatcher';
import cloudFileSystem from 'Cloud/Application/Upload/tools/cloud/cloudFileSystem';
import { EConflictMode } from 'reactApp/types/EConflictMode';

import { sendMyofficeGa } from './sendMyofficeGa';

export const saveDocument = async (item, fileContent: Uint8Array) => {
    try {
        const url = await backendDispatcher.getUploadUrl();
        const hash = await axios.put(url, fileContent, { withCredentials: true });
        const result = await cloudFileSystem.addFile(item.home, hash.data, fileContent.byteLength, EConflictMode.REWRITE);

        sendMyofficeGa('save-success');

        return { result };
    } catch (error) {
        sendMyofficeGa('save-error');

        return { error };
    }
};
